export const ORIGIN_CAMPAIGN_SOAT = 'cross-selling';
export const ORIGIN_CONTENT_SOAT = 'soat-digital';
export const SOAT_PATH = 'comprar/soat-digital';